// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: false,
  applicationInsights: {
    instrumentationKey: 'b67fc025-c6d7-42bf-81cb-d252200285d3',
    enableDebug: true,
    maxAjaxCallsPerView: 10
  },
  pollTime: 15000,
  defaultParadiseVersion: '3.1.76',
  defaultParadiseServerVmSize: 'Standard_D3_v2',
  defaultTrainingVmSize: 'Standard_NV6', // 'Standard_D3_v2',
  defaultVmUserName: 'ParadiseUser',
  defaultVmPassword: 'Geophysical!'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts